module.exports = __webpack_public_path__ + "static/media/javitott_meglevo_fooldal5.3fa07a79.jpg";